//
// [アドイン]偽装ログイン履歴モーダル（サーバー対応）
//
// ./AdminLoginLogModal.js
//


import React, { useEffect, useState } from 'react';
import * as XLSX from 'xlsx';
import { useEscapeClose } from '../hooks/useEscapeClose';
import DoubleConfirmModal from './doubleConfirmModal';

function AdminLoginLogModal({ onClose, ...props }) {
   useEscapeClose(onClose); // ← Escキーでモーダルを閉じる

  const [logEntries, setLogEntries] = useState([]);
  const [modalConfig, setModalConfig] = useState(null);

  useEffect(() => {
    fetch("https://newells4610.stars.ne.jp/data/adminAttemptLog.json", { cache: "no-store" })
      .then(res => res.json())
      .then(parsed => {
        if (Array.isArray(parsed)) setLogEntries(parsed.reverse());
      })
      .catch(err => console.error("ログ読み込み失敗", err));
  }, []);

// エクセル出力 --------------------------------------------------------

  const exportToExcel = async () => {
    try {
      const res = await fetch("https://newells4610.stars.ne.jp/data/adminAttemptLog.json", {
        cache: "no-store"
      });
      const logEntries = await res.json();

      if (!Array.isArray(logEntries) || logEntries.length === 0) {
        setModalConfig({
          message: "出力する履歴がありません",
          onConfirm: () => setModalConfig(null),
        });
        return;
      }


    // (1) データ整形
      const wsData = logEntries.map(log => ({
        '日時': new Date(log.datetime).toLocaleString(),
        'ユーザー名': log.userName,
        'ID': log.userId,
        '内容': log.message,
      }));

    // (2) ワークシート作成
      const ws = XLSX.utils.json_to_sheet(wsData);
      
    // (3) 列幅自動設定
      const getVisualLength = str => [...(str || '')].reduce((acc, char) => acc + (char.charCodeAt(0) > 255 ? 2 : 1), 0);
      const headers = ['日時', 'ユーザー名', 'ID', '内容'];
      const maxLengths = headers.map(key =>
        Math.max(...wsData.map(row => getVisualLength(row[key] || '')))
      );
      ws['!cols'] = maxLengths.map(len => ({ wch: len + 2 }));

    // (4) ワークブック生成 & シート追加
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, '偽装ログイン履歴');

    // (5) 保存
      const fileName = `偽装ログイン履歴_${new Date().toISOString().slice(0, 10)}.xlsx`;
      XLSX.writeFile(wb, fileName);
    } catch (err) {
      console.error("ログ出力失敗", err);
      setModalConfig({
        message: "ログ出力に失敗しました",
        onConfirm: () => setModalConfig(null),
      });
    }
  };

  // 偽装ログイン履歴の完全削除 ------------------------------------------------------------

  const clearLog = async () => {
    // Step 1: 確認モーダルを表示
    setModalConfig({
      message: "偽装ログイン履歴を完全に削除しますか？",
      showCancel: true,
      onConfirm: async () => {
        setModalConfig(null);
        try {
          const res = await fetch("https://newells4610.stars.ne.jp/api/update_adminlog.php", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ entries: [] })  // ← 空配列を送るだけ！
          });
          const result = await res.json();
          if (result.status === "ok") {
            setLogEntries([]);
            setModalConfig({
              message: "ログをクリアしました！",
              onConfirm: () => setModalConfig(null),
            });
          } else {
            setModalConfig({
              message: "ログ削除に失敗：" + result.message,
              onConfirm: () => setModalConfig(null),
            });
          }
        } catch (err) {
          console.error("ログ削除失敗", err);
          setModalConfig({
            message: "通信エラーが発生しました",
            onConfirm: () => setModalConfig(null),
          });
        }
      },
      onCancel: () => setModalConfig(null),
    });
  };


// ------------------------------------------------------------------------------------------
  return (
    <>
      <div className="modal-overlay">
        <div className="modal-box">
          <h4>偽装ログイン履歴</h4>

          <div className="modal-list small-text" style={{ maxHeight: '60vh', overflowY: 'auto' }}>
            {logEntries.length === 0 ? (
              <p>記録はありません。</p>
            ) : (
              (() => {
                let lastDate = '';
                return logEntries.map((entry, idx) => {
                  const d = new Date(entry.datetime);
                  if (isNaN(d)) return null;      // 日付不正は無視
                  const dateStr = d.toLocaleDateString();
                  const showDate = dateStr !== lastDate;
                  lastDate = dateStr;
                  return (
                    <div key={idx} style={{ marginBottom: '0.5em' }}>
                      {showDate && <strong>{dateStr}</strong>}
                      <div style={{ paddingLeft: '1em' }}>
                        [{d.toLocaleTimeString()}] {entry.message}: {entry.userName}（ID: {entry.userId}）
                      </div>
                    </div>
                  );
                });
              })()
            )}
          </div>

          <div className="modal-actions"
               style={{ display:'flex', justifyContent:'space-between', alignItems:'center', marginTop:'1em' }}>
            <button onClick={exportToExcel}>Excel出力</button>
            <button onClick={clearLog} style={{ backgroundColor:'#faa' }}>ログクリア</button>
            <button onClick={onClose}>閉じる</button>
          </div>
        </div>
      </div>

      {modalConfig && <DoubleConfirmModal {...modalConfig} />}
    </>

  );
}

export default AdminLoginLogModal;
